var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.outerStyle)},[_c('p',{style:(_vm.innerStyle)},[_vm._v(_vm._s((_vm.firstName || " ").charAt(0))+_vm._s((_vm.surname || " ").charAt(0)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }